import React, { useEffect, useState } from 'react'
import lpllogo from '../../assets/images/logo.png';
import suburbanlogo from '../../assets/images/suburban.webp'
import '../../assets/stylesheet/layout.scss';
import '../../assets/stylesheet/feedback.scss';
import 'font-awesome/css/font-awesome.min.css';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';
import { ShowToastUtil } from '../../utilities/showToastUtil';
import { Button } from 'react-bootstrap';
import GetUserData from '../../utilities/getUserDetails';

function ReferPage() {
    const [preferedLanguage, setPreferedLanguage] = useState('');
    const [projectFilter, setProjectFilter] = useState('');
    const location = useLocation();
    const query = queryString.parse(location.search);
    const userSelectedLang = decodeURIComponent(query.lang);
    const selectedProject = decodeURIComponent(query.project);
    const [userInfo, setUserInfo] = useState(GetUserData());
    const navigate = useNavigate();
    const [selectedRating, setSelectedRating] = useState('');
    useEffect(() => {
        setPreferedLanguage(userSelectedLang);
    }, [userSelectedLang]);
    useEffect(() => {
        setProjectFilter(selectedProject);
    }, [selectedProject]);

    const handleRating = (e) => {
        setSelectedRating(e.target.value);

    };
    const handleNextBtn = () => {
        if (selectedRating) {
            navigate(`/likeService?selectedRating=${encodeURIComponent(selectedRating || '')}&lang=${preferedLanguage}&project=${projectFilter}`);
        }
        else {
            ShowToastUtil('Please selected a rating', 'warning');
        }
    };
    var primaryQuestion = '';
    const isSuburban = userInfo?.Company?.toLowerCase() === "sdpl";
    if (projectFilter == 1) {

        if (userInfo?.Company?.toLowerCase() === "sdpl") {
            if (preferedLanguage == 'eng') {
                primaryQuestion = 'Based on your Sample Collection Experience, would you recommend Suburban Diagnostics India Pvt Limited to your family/friends?';
            }
            else if (preferedLanguage == 'hin') {
                primaryQuestion = 'सैम्पल कलेक्शन के साथ आपके अनुभव के आधार पर, क्या आप अपने परिवार/ दोस्तों को सबर्बन डायग्नोस्टिक्स इंडिया प्रायव्हेट लिमिटेड की सिफारीश करेंगे?';
            }
        }
        else {
            if (preferedLanguage == 'eng') {
                primaryQuestion = 'Based on your Sample Collection Experience, would you recommend Dr. Lal PathLabs to your family/friends?';
            }
            else if (preferedLanguage == 'hin') {
                primaryQuestion = 'सैम्पल कलेक्शन के साथ आपके अनुभव के आधार पर, क्या आप अपने परिवार/ दोस्तों को डॉ. लाल पॅथलैब्स की सिफारीश करेंगे?';
            }           
        }
    }
    else if (projectFilter == 4) {
        if (userInfo?.Company?.toLowerCase() === "sdpl") {
            if (preferedLanguage == 'eng') {
                primaryQuestion = 'Based on your Contact Centre Experience, would you recommend Suburban Diagnostics India Pvt Limited to your family/friends?';
            }
            else if (preferedLanguage == 'hin') {
                primaryQuestion = 'कॉन्टैक्ट सेंटर के साथ आपके अनुभव के आधार पर, क्या आप अपने परिवार/ दोस्तों को सबर्बन डायग्नोस्टिक्स की सिफारीश करेंगे?';
            }
        }
        else {
            if (preferedLanguage == 'eng') {
                primaryQuestion = 'Based on your Contact Centre Experience, would you recommend Dr. Lal PathLabs to your family/friends?';
            }
            else if (preferedLanguage == 'hin') {
                primaryQuestion = 'कॉन्टैक्ट सेंटर के साथ आपके अनुभव के आधार पर, क्या आप अपने परिवार/ दोस्तों को डॉ. लाल पॅथलैब्स की सिफारीश करेंगे?';
            }
        }
    }
    else if (projectFilter == 5) {
        if (userInfo?.Company?.toLowerCase() === "sdpl") {
            if (preferedLanguage == 'eng') {
                primaryQuestion = 'How satisfied are you with the resolution provided by Suburban Diagnostics India Pvt Limited on your Query/Issue?';
            }
            else if (preferedLanguage == 'hin') {
                primaryQuestion = 'आपके प्रश्न/ समस्या के लिए सबर्बन डायग्नोस्टिक्स इंडिया प्रायव्हेट लिमिटेड द्वारा दिए गए समाधान से आप कितने संतुष्ट हैं?';
            }
        }
        else {

            if (preferedLanguage == 'eng') {
                primaryQuestion = 'How satisfied are you with the resolution provided by Dr. Lal PathLabs on your Query/Issue?';
            }
            else if (preferedLanguage == 'hin') {
                primaryQuestion = 'आपके प्रश्न/ समस्या के लिए डॉ. लाल पॅथलैब्स द्वारा दिए गए समाधान से आप कितने संतुष्ट हैं?';
            }
        }
    }
    return (
        <>
            <div className='container-fluid feedback-form'>
                <div className='row'>
                    <div className='col-14 col-sm-14 col-md-9 col-lg-9 col-xl-9 '>
                        <div className='logo-section'>
                            {isSuburban ? (
                                <img alt="Suburban Diagnostics India Pvt Limited" className='f-logo' src={suburbanlogo} />
                            ) : (
                                <img alt="Dr Lal Path Labs" className='f-logo' src={lpllogo} />
                            )}
                        </div>
                    </div>
                    <div className='col-14 col-sm-14 col-md-8 col-lg-8 col-xl-8'>
                        <div className='form-section'>
                            <div className='row'>
                                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center'>
                                    <h5 className='feedback-title mb-5'>
                                        {primaryQuestion}
                                    </h5>
                                    <div className='smily-wrapper'>
                                        <div className='smily happy'>
                                            <input type="radio" name="emotion" id="happy" value={'promotor'} onClick={handleRating} />
                                            <label for="happy" className='happy'><i className='fa fa-smile-o'></i> </label>
                                        </div>
                                        <div className='smily '>
                                            <input type="radio" name="emotion" id="nutral" value={'passive'} onClick={handleRating} />
                                            <label for="nutral" className='nutral'><i className='fa fa-meh-o'></i> </label>
                                        </div>
                                        <div className='smily'>
                                            <input type="radio" name="emotion" id="sad" value={'detractor'} onClick={handleRating} />
                                            <label for="sad" className='sad'><i className='fa fa-frown-o'></i> </label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='button-footer text-center'>
                            <div className='row justify-content-center'>
                                <div className='col-10 col-sm-6 col-md-4 col-lg-2 col-xl-2'>
                                    <Button variant='primary w-100' style={{ minHeight: '36px', borderRadius: '20px' }} onClick={handleNextBtn}>Next</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ReferPage;
